<template>
  <form class="stepoptions">
    <fieldset>
      <legend>
        <div class="step_options_header">
          <span class="num">
            <i>{{ currentStep }}</i>
          </span>
          <span class="txt">
            <h6>Select Your {{ step.title }}</h6>
            <span>{{step.intro}}</span>
          </span>
          <button
            type="button"
            class="clear_selection"
            @click="clearSelection()"
            :disabled="clearButtonDisabled"
          >
            Clear Selection
          </button>
        </div>
      </legend>

      <div class="table" :class="{ [step.columns]: shouldOutputColumnCount }">
        <step-options-list-item
          v-for="(option, index) in allowedOptions"
          :key="index"
          :option="option"
          :selection="internalSelection"
          :showConfiguratorPricing="showConfiguratorPricing"
          @step-option-selected="emitOptionSelected"
        />
      </div>
    </fieldset>
  </form>
</template>

<script>
import StepOptionsListItem from "./StepOptionsListItem";
import EventBus from "../../../event_bus";

export default {
  props: ["step", "pointer", "selection", "showConfiguratorPricing"],
  data() {
    return {
      internalSelection: this.selection || null,
    };
  },
  computed: {
    currentStep() {
      return parseInt(this.pointer + 1);
    },
    shouldOutputColumnCount() {
      return this.step.options.some((option) => {
        return (
          option.image && option.image.src && option.image.src.url.length > 0
        );
      });
    },
    allowedOptions() {
      const allowedOptions = this.step.options.filter((step) => step.allowed);

      let width;
      let height;
      let maxWidth;
      let skipThisStepImage;

      if (allowedOptions && allowedOptions[0] && allowedOptions[0].image) {
        width = allowedOptions[0].image.src.width;
        height = allowedOptions[0].image.src.height;

        maxWidth = (width < height) ? width : height;
        skipThisStepImage = { width: maxWidth, src: { url: "/assets/images/theme/question-1.svg" } };
      } else {
        skipThisStepImage = null;
      }

      if (this.step.addNotSureOption) {
        allowedOptions.push({
          step_id: this.step.id,
          label: "I'm not sure.",
          image: skipThisStepImage,
          internal_id: "???",
          sku: "???",
          price: 0,
          skipThisStep: true,
          allowed: true,
        });
      }

      return allowedOptions;
    },
    clearButtonDisabled() {
      return !this.selection || (this.internalSelection && this.internalSelection.internal === "???");
    },
  },
  watch: {
    selection: {
      handler: function(value) {
        this.internalSelection = value;
      },
    },
  },
  methods: {
    emitOptionSelected(stepId, sku, price) {
      this.$emit("step-option-selected", stepId, sku, price);
    },
    clearSelection() {
      EventBus.$emit("step-option-cleared", `radio_${this.selection}`);
      this.internalSelection = { external: "???", internal: "???" };

      let selectedOption;
      let inversePrice = 0;

      selectedOption = this.step.options.find(({sku}) => sku === this.selection);

      if (!selectedOption) {
        selectedOption = this.step.options.find(({internal_id}) => internal_id === this.selection.internal);
      }

      inversePrice = (selectedOption.price * -1);

      this.$emit("step-option-selected", this.step.id, this.internalSelection, inversePrice);
    },
  },
  components: {
    "step-options-list-item": StepOptionsListItem,
  },
};
</script>
